import React, { useEffect, useState, useMemo , useRef } from "react";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import "../../../StyleSheet/MainComponent/User/UseDetails.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  setUserActions,
  setUserDeleteActions,
  getSideBarfilesActions,
  SettheUserFilterActions,
  setGeoLoactionStateAction,
  setZoneActions,
  setRegionActions,
  setTheuserprofileID, ///0----user---rpfoile---ids
  setTheUseridEditIds, ///---userid
  setTheUserObjects,
  setTheSignaturePadNumberSet,
  getRoleListActions, ///--Role---listouts
  setTheMonthandYearFilters,
  setTheUserDetailsExportActions,
  setTheAUthoriedID,
  setTheUserDatasFortheFilters,
  setTheUSERDATASStateObject,
  setTheUSERDATASRegionObject,
  setTheUSERDATASZoneObject,
  setTheUSERKYCVERIFIEDObject,
  setThepresentUrlOfSignature,
  SetTheSetUserSignError,
  setTheUSERDATADEigntionsObject,
  setTheUserProfileActive,
  setTheUserDesignationsObject,
  settheUsersStore_filter_monthand_yeas,
  setTablePositionPersist
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import Delete from "../../AppComponent/Popup/Delete";
import UserCreateForm from "./UserCreateForm";
import data from "../../../Json/Language/English";
import hindiDatas from "../../../Json/Language/Hinid";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import swal from "sweetalert2";
import { whitelist } from "validator";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import _ from "lodash";
import { useLocation } from "react-router-dom";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import ViewSymblos from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-23.svg";
import useDebouncedEffect from 'use-debounced-effect';

const UserDetails = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const TablePositionPersist = useSelector(state=>state.PreviousPagePosition.TablePositionPersist)
  const UserObjectData = useSelector((state) => state.users.UserData);

  const Swal = require("sweetalert2");

  const Navigate = useNavigate();
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [Datas, setDatas] = useState([]);
const [search,setsearch] = useState(
    TablePositionPersist?.UDSUserDatas?.search == undefined ||
    TablePositionPersist?.UDSUserDatas?.search == ""
      ? ''
      : TablePositionPersist?.UDSUserDatas?.search
  );  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [UserCreate, setUserCreate] = useState(false);
  const [UserEditPopup, setUserEditPopup] = useState(false);
  const [EditId, setEditID] = useState();
const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.UDSUserDatas?.page == undefined
      ? 1
      : TablePositionPersist.UDSUserDatas.page
  );
    const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState();
  const [usermonthfilter, setMonthFilter] = useState(false);


  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    // {
    //   value: "",
    //   label: "All",
    // },

    {
      value: "1",
      label: "QPMS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);

  const [KYCoptions, setkycoptions] = useState([
    { value: "", label: "ALL" },
    // { value: "0", label: "PAY ROLE" },
    { value: "1", label: "REGIONAL MANAGER" },
    { value: "2", label: "ONBOARDER" },
    { value: "3", label: "SUPER ADMIN" },
    // { value: "4", label: "SUPERVISOR" },
    { value: "5", label: "SKILL ASSESSMENT" },
  ]);

  const [KycValue, setKcyvalue] = useState(
    // KYCoptions[0]

    state.ClientBranchIDs.KYC_Data
  );

  const [sub_role, setsubrole] = useState(state.ClientBranchIDs.KYC_Data.value);
  const HandleKyc = (e) => {
    console.log(e ,"sduaspodi poasidopais d");
    
    setdtPageindex(1);
    if (e != null) {
      dispatch(setTheUSERKYCVERIFIEDObject(e));
      setKcyvalue(e);
      setsubrole(e.value);
      setcounts(2);
    }else{
            dispatch(setTheUSERKYCVERIFIEDObject({ value: "", label: "ALL" }));
      setKcyvalue({ value: "", label: "ALL" });
      setsubrole("");
      setcounts(2);
    }
  };
  // console.log(sub_role, "sub_role");
  const [EMpROleSelected, setEmpRoleSele] = useState(
    // EmpRoles[0]

    state.ClientBranchIDs.EmpDesigna_Zone
  );
  const [filterForWhite, setFilters] = useState({
    // white_collar:state.ClientBranchIDs.EmpDesigna_Zone.value
    white_collar: true,
  });
  // const EnglishData = data;
  const HindiData = hindiDatas;
  ///-------Filters-----------------

  const [State, setState] = useState([]);
  const [multiselect, setMuliselect] = useState([
    //  { value: "", label: "All" }
    // state.ClientBranchIDs.StateName,
    state.ClientBranchIDs.User_datas_State,
  ]);
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.RegionName,
    state.ClientBranchIDs.User_datas_Region,
  ]);
  const [multiselect3, setMuliselect3] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.ZoneName,
    state.ClientBranchIDs.User_datas_Zone,
  ]);
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [counts, setcounts] = useState(1);
  const [data, setData] = useState({
    // zone: state.ClientBranchIDs.ZoneName.value,
    // state: state.ClientBranchIDs.StateName.value,
    // region: state.ClientBranchIDs.RegionName.value,

    zone: state.ClientBranchIDs.User_datas_Zone.value,
    state: state.ClientBranchIDs.User_datas_State.value,
    region: state.ClientBranchIDs.User_datas_Region.value,
  });

  // console.log(data, "39070eUser_datas_State");
  const [yearAndMonth, setYearMpnth] = useState();
  const [RoleOPtions, setRoleOPtions] = useState([]);
  const [RoleData, setRoleData] = useState(state.ClientBranchIDs?.DesignationUSER  ? state.ClientBranchIDs?.DesignationUSER : []);
  const [RoleID, setRoleId] = useState({ roleid: state.ClientBranchIDs?.DesignationUSER ? state.ClientBranchIDs?.DesignationUSER?.value : "" });
  const [rolesearch, setrolesearch] = useState("");
  const date = new Date();
  // console.log(date.getFullYear(), "date");
  const months =
    date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  console.log(yearAndMonth, "yearAndMonth");
  //var yearAndMonth = `${date.getFullYear()}-${months}`;
  useEffect(() => {
    setYearMpnth(`${date.getFullYear()}-${months}`);
  }, []);

  const [Datamonth, setdata] = useState({
    // month: months,
    // year: date.getFullYear(),
  month:state.NumberCounts?.StoreUser_list_filter_monthand_yeas?.month ?
  state.NumberCounts?.StoreUser_list_filter_monthand_yeas?.month: ""
  ,
  year: state.NumberCounts?.StoreUser_list_filter_monthand_yeas?.year ?
  state.NumberCounts?.StoreUser_list_filter_monthand_yeas?.year :
  ""
  });

  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);

  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    RoleSearch:"",
  };

  const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);


  const [monthYearset, setMonthYear] = useState("");

  useEffect(()=>{
    dispatch(settheUsersStore_filter_monthand_yeas(Datamonth))
  },[Datamonth])
  const handleChange = (e) => {
    const inputValue = e.target.value;
    setMonthYear(inputValue);
    setMonthFilter(true);
    setdtPageindex(1);
  
    const months = new Date(inputValue);
    
    // Validate date before proceeding
    if (isNaN(months.getTime())) {
      console.error("Invalid date selected");
      return;
    }
  
    const selectedMonth = String(months.getMonth() + 1).padStart(2, "0"); // Ensures 2-digit format
    const selectedYear = months.getFullYear();
  
    setYearMpnth(`${selectedYear}-${selectedMonth}`);
    console.log(selectedYear, "weurweydsfsd", selectedMonth);
  
    setdata({
      ...Datamonth,
      month: selectedMonth,
      year: selectedYear,
    });
  
    console.log({ month: selectedMonth, year: selectedYear }, "Date filters");
  };
  
  
  ///---role----based exports---

  const handelRoleIdForExports = (e) => {
    setdtPageindex(1);
    if (e != null) {
          dispatch(setTheUserDesignationsObject((e)))

      setRoleData(e);
      setRoleId({
        ...RoleID,
        roleid: e.value,
      });
    } else if (e == null) {
      setRoleData({});
      setRoleId({
        ...RoleID,
        roleid: "",
      });
          dispatch(setTheUserDesignationsObject(({value:"",label:"All"})))

    }
  };

  const UserDetailsExports = (e, statement, values) => {
    console.log(values, "values");
    const IDS = values == "single" || RoleID.roleid == "" ? e : "";
    Swal.fire({
      title: `Are you sure, do you want to export the user Details records for ${filterForWhite.white_collar == true ? "QPMS Role" : "Client Role"
        } ?`,
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Export it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const payloads = {
          export_type: values,
          role_id:
            RoleID.roleid != "" && values != "single" ? RoleID.roleid : "",
          user_id: IDS,
        };
        console.log(payloads, "payloadskehqiwu2873409");
        dispatch(setTheUserDetailsExportActions(payloads));
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };

  useEffect(() => {
    const payload = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      white_collar: filterForWhite.white_collar,
      // month: Datamonth.month,
      // year: Datamonth.year,
      role: RoleID.roleid,
      sub_role: sub_role,
      state: data.state,
      region: data.region,
      zone: data.zone,
    };

    dispatch(setTheSignaturePadNumberSet(1)); // signaturePad , number counts
  // if (
  //     state.Usergetlists.UserList.length == 0 ||
  //     TablePositionPersist?.UDSUserDatas?.page != dtpageindex ||
  //     TablePositionPersist?.UDSUserDatas?.search != search ||
  //     TablePositionPersist?.UDSUserDatas?.year != Datamonth.year ||
  //     TablePositionPersist?.UDSUserDatas?.month != Datamonth.month ||
  //     TablePositionPersist?.UDSUserDatas?.white_collar != filterForWhite.white_collar ||
  //     TablePositionPersist?.UDSUserDatas?.sub_role != sub_role ||
  //     TablePositionPersist?.UDSUserDatas?.zone != data.zone ||
  //     TablePositionPersist?.UDSUserDatas?.region != data.region ||
  //     TablePositionPersist?.UDSUserDatas?.state != data.state ||
  //     TablePositionPersist?.UDSUserDatas?.updated


  //     // apiTriggerCount == true
  //   ) {  
    dispatch(setUserActions(payload));


    dispatch(
      setTablePositionPersist({ data: payload, pageName: "UDSUserDatas" })
    );


    // }

    currentRef.current.scrollTop=sessionStorage.getItem("UDSUsersListPageTableScrollPosition")

    setDatas(state.Usergetlists.UserList);
  }, [
    dtpagesize,
    filterForWhite,
    Datamonth,
    dtpageindex,
    RoleID,
    data,
    sub_role,
    search,
  ]);
  // console.log(Datamonth, "389640932794Datamonth");
  const HandleEMprole = (e) => {
    if (e != null) {
      setEmpRoleSele(e);
      setdtPageindex(1);

      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
        dispatch(setTheUSERDATADEigntionsObject({ value: true, label: "UDS" }));
      } else if (e.value == 2) {
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
        setKcyvalue({ value: "", label: "ALL" });

        setsubrole("");

        dispatch(
          setTheUSERDATADEigntionsObject({ value: false, label: "Client" })
        );
      }
      //  else if(e.value == ""){
      //   setFilters({
      //     ...filterForWhite,
      //     white_collar: "",
      //   });

      //  }
    }
  };

 
  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
        });
        setrolesearch(SearchDebounance.RoleSearch);

      }
    },
    500,
    [SearchDebounance]
  );

 ///-----State----Input Changes
 const handleInputChange = (Val) => {
  console.log(Val, "Values");
  setSearchDebounance({
    ...SearchDebounance,
    stateSearch: Val,

  });
};
//---Zone----
const handleInputZone = (Val) => {
  setSearchDebounance({
    ...SearchDebounance,
    zoneSearch:Val,
  });
};
///----Regions----
const handleInputRegion = (Val) => {
  setSearchDebounance({
    ...SearchDebounance,
    regionSearch: Val,
  });
};
  useEffect(() => {
    const payloads = {
      search: rolesearch,
      page_size: 20,
      page: 1,
      mode: "all",
      client: "",
      white_collar: filterForWhite.white_collar,
      month: "",
      year: "",
    };
    dispatch(getRoleListActions(payloads));
  }, [filterForWhite, rolesearch]);

  // const debouncedRoleSearch = useMemo(
  //   () =>
  //     _.debounce((e) => {
  //       const payloads = {
  //         search: e,
  //         page_size: 20,
  //         page: 1,
  //         mode: "all",
  //         client: "",
  //         white_collar: filterForWhite.white_collar,
  //         month: "",
  //         year: "",
  //       };
  //       dispatch(getRoleListActions(payloads));
  //     }, 500),
  //   []
  // );

  const HandleRoleAPi = (e) => {

    setSearchDebounance({
      ...SearchDebounance,
      RoleSearch:e
    })
  };
  useEffect(() => {
    if (state.rolelists.RoleList != undefined) {
      let objectArray = [];
      state.rolelists.RoleList.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.role.toUpperCase(),
        });
      });

      setRoleOPtions(objectArray);
    }
  }, [state.rolelists.RoleList, filterForWhite, rolesearch]);
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {

        setsearch(e);
      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);
  const HandleSubmits = () => {
    setsearch("");
    if (DeleteID != undefined) {
      const payload = {
        DeleteID: DeleteID,
        currentPage: dtpageindex,
        month: Datamonth.month,
        year: Datamonth.year,
        white_collar: true,
        // role: RoleID.roleid,
        sub_role: sub_role,
        state: data.state,
        region: data.region,
        zone: data.zone,
        GetAPICALL: 1,
        role_filter:RoleID?.roleid
      };
      dispatch(setUserDeleteActions(payload, setDeletePopup(false)));
    }
  };

  function maxword(data) {
    const maxLength = 7; // Set your desired maximum length
    const ellipsis = "..."; // Set your ellipsis string

    return data.length > maxLength
      ? `${data.substring(0, maxLength)}${ellipsis}`
      : data;
  }

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  
    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + "...";
    };
  

  const columns = [
//       {
//   Header: "U-ID",
//   accessor: "user_id.local_uid",
//   Cell: ({ row }) => {
//     const userId = row.original?.user_id?.local_uid;

//     // Handle null, undefined, empty string, or whitespace
//     const displayValue =
//       userId == null || String(userId).trim() == "" ? "--" : userId;

//     return <p className="PTAGs">{displayValue}</p>;
//   },
// },
{
  Header: "User Code",
  accessor: "",
  Cell: (row) => {
    const code = row.row.original.user_uid;

    const displayValue =
      code ? (code.length > 10 ? code.substring(0, 10) + "..." : code) : "--";

    return (
      <div className="UserName" style={{ cursor: "pointer" }}>
        <span>{displayValue}</span>
      </div>
    );
  },
},
    {
      Header:  "Name" ,
      accessor: "",

      Cell: (row) => {
                const [showTooltip, setShowTooltip] = useState(false);

        return (
              <>
            <span>
              {row.row.original.first_name != null &&
                row.row.original.first_name != undefined &&
                row.row.original.first_name != "" ? (
                <div className="UserName"
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  style={{ position: 'relative' }}
                >

                  <>
                    {
                      row.row.original.first_name.length > 15 ? (
                        truncateText(capitalizeFirstLetter(row.row.original.first_name), 15)
                      ) :
                      (
                        <>{row.row.original.first_name}</>
                      )}
                  </>
                  {showTooltip && (
                    <div className="custom-tooltip">
                      {row.row.original.first_name}
                    </div>
                  )}

                </div>
              ) : (
                <span>{"---"} </span>
              )}
            </span>
          </>
        );
      },
    },
    {
      Header: "Email",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);

        return (
          <>
            {row.row.original.email != "" &&
              row.row.original.email != undefined &&
              row.row.original.email != undefined &&
              row.row.original != undefined ? (
              <div
                className="UserName"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                style={{ position: "relative" }} // Relative positioning for tooltip placement
              >
                <span>
                  {row.row.original.email}
                </span>
                {showTooltip && (
                  <div className="custom-tooltip">
                    {row.row.original.email}
                  </div>
                )}
              </div>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },

    // {
    //   Header: "Role",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         {row.row.original.user_role.role != undefined &&
    //         row.row.original.user_role.role != "" &&
    //         row.row.original.user_role.role != undefined ? (
    //           <span
    //             data-tooltip-id="Name-ToolTips"
    //             data-tooltip-content={row.row.original.user_role.role}
    //           >
    //             {
    //             // row.row.original.user_role.role.length > 15 ? (
    //             //   <>{row.row.original.user_role.role.slice(0, 14)}...</>
    //             // )
    //             //  :
    //               (
    //               <>{row.row.original.user_role.role}</>
    //             )}
    //           </span>
    //         ) : (
    //           <span>{"--"}</span>
    //         )}
    //       </>
    //     );
    //   },
    // },
    {
      Header: "Designation",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);

        return (
          <>
            <span>
              {row.row.original.user_role.role != null &&
                row.row.original.user_role.role != undefined &&
                row.row.original.user_role.role != "" ? (
                <div className="UserName"
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  style={{ position: 'relative' }}
                >

                  <>
                    {
                      row.row.original.user_role.role.length > 10 ? (
                        truncateText(row.row.original.user_role.role, 10)
                      ) :
                      (
                        <>{row.row.original.user_role.role}</>
                      )}
                  </>
                  {showTooltip && (
                    <div className="custom-tooltip">
                      {row.row.original.user_role.role}
                    </div>
                  )}

                </div>
              ) : (
                <span>{"---"} </span>
              )}
            </span>
          </>
        );
      },
    },
    {
      Header: "Phone Number",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.phone_number != undefined ? (
              <span>{row.row.original.phone_number}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Kyc Role",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.sub_role != undefined &&
              row.row.original.sub_role != "" ? (
              <>
                {row.row.original.sub_role == "0" ? (
                  <span className="KYcRoles">{"---"}</span>
                ) : (
                  <>
                    {row.row.original.sub_role == "1" ? (
                      <span className="KYcRoles">{"REGIONAL MANAGER"}</span>
                    ) : (
                      <>
                        {row.row.original.sub_role == "2" ? (
                          <span className="KYcRoles">{"ONBOARDER"}</span>
                        ) : (
                          <>
                            {row.row.original.sub_role == "3" ? (
                              <span className="KYcRoles">{"SUPER ADMIN"}</span>
                            ) : (
                              <>
                                {row.row.original.sub_role == "4" ? (
                                  <span className="KYcRoles">
                                    {"SUPERVIORS"}
                                  </span>
                                ) : (
                                  <span className="KYcRoles">{row.row.original.sub_role == "5" ?

                                    <span className="KYcRoles">
                                      {"SKILL ASSESSMENT"}
                                    </span>
                                    :
                                    <span className="KYcRoles">
                                      {"---"}
                                    </span>

                                  }</span>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Created Date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <div className="CreatedDatelisted">
              {`${row.row.original.created_at.slice(0, 10)
                //  + "  " + formattedTime
                }`}
            </div>
          </>
        );
      },
    },

    {
      Header: "Last Login",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.last_login;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
        const [showTooltip, setShowTooltip] = useState(false);

        return (
          <>
            {row.row.original.last_login != null ? (
              <>
                <div className="CreatedDatelisted"
                  style={{ width: "103px" }}
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}

                >
                  {`${row.row.original.last_login.slice(0, 10)
                    // + "  " + formattedTime
                    }`}
                </div>


                {showTooltip && (
                  <div className="custom-tooltip_time">
                    {formattedTime}
                  </div>
            )}  
              </>


            )
              :
              <div className="CreatedDatelisted"
                style={{ width: "103px" }}
              >
                --
              </div>

            }
          </>
        );
      },
    },

    filterForWhite.white_collar && {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                component="span"
                onClick={(e) => {
                  e.stopPropagation();
                  setUserEditPopup(true);
                  dispatch(
                    setTheMonthandYearFilters({
                      month: Datamonth.month,
                      year: Datamonth.year,
                    })
                  ); /// sane as inside the branch lis
                  const Datas = {
                    white_collar: filterForWhite.white_collar,
                    state: data.state,
                    region: data.region,
                    zone: data.zone,
                    search: search,
                  };
                  dispatch(setTheUserDatasFortheFilters(Datas));
        dispatch(SetTheSetUserSignError(""));

                  dispatch(setTheUseridEditIds(row.row.original.id));
                  setEditID(row.row.original.id);
                }}
              >

                <span className="OuterActionSpan">
                  <span className="EditImages">
                    <img src={EditImages} />
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>

              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setThepresentUrlOfSignature(""))
                  dispatch(SetTheSetUserSignError(""));
                  setsearch("");
                  setDeleteId(row.row.original.id);
                  setDeletePopup(true);
                }}
              >
                {/* <span>
                  <i
                    class="fa-regular fa-trash-can"
                    style={{
                      fontSize: "15px",
                      paddingRight: "3px",
                      paddingBottom: "3px",
                    }}
                  ></i>
                  Delete
                </span> */}

                <span className="OuterActionSpan">

                  <span className="EditImages">
                    <img src={DeleteImages} />
                  </span>

                  <span className="ActionsList"> Delete </span>
                </span>
              </button>

              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  e.stopPropagation();

                  dispatch(setTheuserprofileID(row.row.original.id));
                  Navigate("/userprofile");
                }}
              >
                {/* <span>
                  {" "}
                  <i
                    class="fa-regular fa-eye"
                    style={{
                      fontSize: "15px",
                      paddingRight: "3px",
                      paddingBottom: "3px",
                    }}
                  ></i>
                  View
                </span> */}

                <span className="OuterActionSpan">
                  {/* <i
                    class="fa-regular fa-eye"
                    style={{
                      fontSize: "15px",
                      paddingRight: "3px",
                      paddingBottom: "3px",
                    }}
                  ></i> */}

                  <span className="EditImages">
                    <img src={ViewSymblos} />
                  </span>

                  <span className="ActionsList"> View </span>
                </span>
              </button>

              {/*               
              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  const id = row.row.original.id;
                  e.stopPropagation();

                  UserDetailsExports(id, true, "single");
                }}
              >
                <span>
                  {" "}
                  <i
                    class="fa-solid fa-file-export"
                    style={{
                      fontSize: "15px",
                      paddingRight: "3px",
                      paddingBottom: "3px",
                    }}
                  ></i>
                  Export
                </span>
              </button>

 */}
            </div>
          </>
        );
      },
    },
    // {
    //   Header: "Last Login",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         {row.row.original.last_login != undefined && row.original.last_login != null ? (
    //           <span>{row.row.original.last_login}</span>
    //         ) : (
    //           <span>{"--"}</span>
    //         )}
    //       </>
    //     );
    //   },
    // },
  ].filter(Boolean);
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  ///----Search------For----the----filters---------------
  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
    setState(state.GeoState.State);
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: currentPage,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);
  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);

  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    setdtPageindex(1);

    if (selectedVal != null) {
      dispatch(setTheUSERDATASZoneObject(selectedVal));

      setMuliselect3(selectedVal);
      setData({
        ...data,
        zone: selectedVal.value,
      });
      setcounts(2);
    }
    if (selectedVal == null && data.region == null && data.state == null) {
      setData({
        ...data,
        zone: "",
      });
      console.log(data.zone, "ZONES");

      setMuliselect3({ value: "", label: "Select" });


      setcounts(1);
    }
    if (selectedVal == null) {
      setMuliselect3({ value: "", label: "Select" });
      setData({
        ...data,
        zone: "",
      });
      dispatch(setTheUSERDATASZoneObject({ value: "", label: "ALL" }));
    }
  };
  //----Regions-----------------
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setData({
        ...data,
        region: selectedVal.value,
      });
      setcounts(2);
      setMuliselect3({ value: "search", label: "Search" });

      dispatch(setTheUSERDATASRegionObject(selectedVal));

      dispatch(setTheUSERDATASZoneObject({ value: "", label: "ALL" }));
    }
    if (selectedVal == null && data.state == null && data.zone == null) {
      setData({
        ...data,
        region: "",
        zone: "",
      });

   

      setcounts(1);
    }

    if (selectedVal == null) {
      setData({
        ...data,
        region: "",
        zone: "",
      });
      dispatch(setTheUSERDATASRegionObject({ value: "", label: "ALL" }));

      dispatch(setTheUSERDATASZoneObject({ value: "", label: "ALL" }));

      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
    }
  };

  //----Handle----Remove -----in----Regions
  const handleRemove = (e) => {
    setMuliselect1(e);
    // console.log(e, "Removed", data.region);
    setData({
      ...data,
      region: "",
    });
    setcounts(2);
    if (e == null) {
 
      setcounts(1);
    }
  };
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });
      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  //---------------State0------------------------
  useEffect(() => {
    const Datas = [];
    setState(state.GeoState.State.state_name);
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);

  ///----State----------Changes-----------------------
  const handleSelectChange = (selectedVal) => {
    setdtPageindex(1);
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      console.log(selectedVal, "asfad");
      setData({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
      setcounts(2);
      dispatch(setTheUSERDATASStateObject(selectedVal));
      dispatch(setTheUSERDATASRegionObject({ value: "", label: "ALL" }));

      dispatch(setTheUSERDATASZoneObject({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "search", label: "Search" });
      setMuliselect3({ value: "search", label: "Search" });
      setMuliselect({ value: "", label: "ALL" });
      dispatch(setTheUSERDATASStateObject({ value: "", label: "ALL" }));
      dispatch(setTheUSERDATASRegionObject({ value: "", label: "ALL" }));

      dispatch(setTheUSERDATASZoneObject({ value: "", label: "ALL" }));

      setData({
        ...data,
        state: "",
        region: "",
        zone: "",
      });
    

      setcounts(1);
    }
  };

  ///--profile---------
  const ViewFunctions = (e) => {
    if (filterForWhite.white_collar) {
      dispatch(setTheuserprofileID(e.id));
dispatch(setTheUserProfileActive(5));
      // dispatch(setTheAUthoriedID(e.authorized_person.id))
        dispatch(SetTheSetUserSignError(""));

      /// dispatch the authoried person id
      ////----Dispatch the objects ,

      dispatch(
        setTheUserObjects({
          value: e.id,
          label: e.first_name,
        })
      );

      if (e.id == state.ClientBranchIDs.userProfileId) {
        Navigate("/userprofile");
      }
    }
  };


  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage)
  }

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);

    }
  };

const currentRef = useRef();
const scrollPosition = (e) => {
  const val = currentRef.current.scrollTop;
  sessionStorage.setItem("UDSUsersListPageTableScrollPosition", val);
};


  return (
    <>
      <div 
            onScroll={scrollPosition}
      ref={currentRef}      
      className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            // className="InnerUsers col-md-6"
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3 class="user-name mb-0">User</h3>

          </div>
          <div className="Add-User col-sm-5">
            <button
              onClick={(e) => {
                dispatch(setThepresentUrlOfSignature(""))
                dispatch(SetTheSetUserSignError(""));
                setUserCreate(true);
                dispatch(
                  setTheMonthandYearFilters({
                    month: Datamonth.month,
                    year: Datamonth.year,
                  })
                );
                const Datas = {
                  white_collar: filterForWhite.white_collar,
                  state: data.state,
                  region: data.region,
                  zone: data.zone,
                  search: search,
                };
                dispatch(setTheUserDatasFortheFilters(Datas));

                // window.location.href = "/usercreate";
                Navigate("/usercreate");
              }}
              className="ButtonCSS"
            >
              Create
            </button>
          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
            marginTop: "-30xp",
            marginLeft: "0px",
            marginRight: "0px",
            //  / border:"3px solid red " ,
            top: "-10px",
          }}
        >
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              State
            </label>
            <Select
              // className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onremoved={(e) => {
                setMuliselect(e);
              }}
              onInputChange={handleInputChange}
              labelledBy="Select"
              value={multiselect}
            />
          </div>
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Region
            </label>
            <Select
              // className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
    isClearable={
  multiselect1
    ? Array.isArray(multiselect1)
      ? multiselect1.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect1.label === "ALL" || multiselect1.label === "All"
      ? false
      : true
    : true
}
              onremoved={(e) => {
                handleRemove(e);
                //  setMuliselect1(e);
                console.log(e, "jjk9090");
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
            // placeholder={
            //   data.state == ""
            //     ? "without selected state you can't select Region"
            //     : "search"
            // }
            />
          </div>
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Zone
            </label>
            <Select
              // className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              options={nameList4}
               isClearable={
  multiselect3
    ? Array.isArray(multiselect3)
      ? multiselect3.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect3.label === "ALL" || multiselect3.label === "All"
      ? false
      : true
    : true
}              onremoved={(e) => {
                setMuliselect3(e);
                //  console.log(e, "jjk9090");
              }}
              value={multiselect3}
              onInputChange={handleInputZone}
              //  onRemove={(e) => console.log(e, "ZONE_REMOVE")}
              labelledBy="Select"
            // placeholder={
            //   data.state == ""
            //     ? "without selected state you can't select Zone"
            //     : data.region == ""
            //     ? "without selected Region you can't select Zone"
            //     : "Search"
            // }
            />
          </div>

          <div className="col-sm-2">
            <label
              for="validationCustom01"
              class="form-label"
            // style={{
            //   textAlign: "left",
            //   display: "flex",
            //   flexDirection: "row",
            // }}
            >
              Designation
            </label>
            <Select
              // className="Selects"
              styles={{ position: "relative", top: "60px" }}
              isClearable={true}
              options={RoleOPtions}
              value={RoleData}
              onChange={(e) => {
                handelRoleIdForExports(e);
              }}
              onInputChange={(e) => {
                HandleRoleAPi(e);
              }}
            />
          </div>

        {/* <div className="col-sm-2" style={{ paddingTop: "27px" }}>
            <button
              style={{
                padding: "0px !important",
                background: "#F47C38",
                color: "white",
              }}
              class=" ButtonCSS"
              onClick={(e) => {

                if (RoleID.roleid == "") {
                  toast.error(
                    ` ${"After Selected the role then only you can download the data"} `,
                    {
                      position: toast.POSITION.TOP_RIGHT,
                    }
                  );
                } else if (RoleID.roleid != "") {
                  UserDetailsExports(e, true, "multi");
                }
              }}
            >
              Download Data
            </button>
          </div>  */}

          <div className="col-sm-2" style={{ paddingTop: "23px" }}>
            <button
              align="center"
              type="button"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                background: "transparent",
              }}
              className="DownloadBTNS"
              onClick={(e) => {
                if (RoleID.roleid == "") {
                  toast.error(
                    ` ${"After Selected the role then only you can download the data"} `,
                    {
                      position: toast.POSITION.TOP_RIGHT,
                    }
                  );
                } else if (RoleID.roleid != "") {
                  UserDetailsExports(e, true, "multi");
                }
              }}
            >
              <a class="dnbtn"></a>
            </button>
          </div>
        </div>

        {Datas != undefined ? (
          <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
            {/* <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                position: "relative",
                top: "95px",
                width: "92%",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <div style={{ width: "314px" }}></div>
              <div
                class=" field-div"
                style={{
                  position: "relative",
                  top: "-16px",
                  display: "flex",
                  justifyContent: "flex-end",
                  flexDirection: "column",
                  zIndex: "1",
                  width: "351px",
                }}
              >
                <label
                  for="validationCustom02"
                  class="form-label"
                  style={{ fontSize: "15px" }}
                >
                  Employee Role
                </label>

                <Select
                  className="Selects"
                  styles={{ position: "relative", top: "60px" }}
                  onChange={(e) => {
                    HandleEMprole(e);
                  }}
                  value={EMpROleSelected}
                  options={EmpRoles}
                  placeholder="search"
                />
              </div>
            </div> */}

            <ReactTable
              data={
                state.Usergetlists.UserList
                // counts == 1
                // ? state.Usergetlists.UserList
                // : state.UserFilterCall.UserFIlterState
              }
              columns={columns}
              currentPage={currentPage}
              totalItems={
                // counts == 1
                //   ? state.Usergetlists.Total_Count
                //   : state.UserFilterCall.Total_Count
                state.Usergetlists.Total_Count
              }
              pagesize={pagesize}
              dtpagesize={pageSize}
              pageindex={pageindex}
              datacount={
                // counts == 1
                //   ? state.Usergetlists.Total_Count
                //   : state.UserFilterCall.Total_Count
                state.Usergetlists.Total_Count
              }
              onChange={tochange}
              Oncreate={(e) => {
                setEditID("");
                setUserCreate(true);
                if (EditId == "" || EditId == undefined || EditId == null) {
                  window.location.href = "/usercreate";
                }
              }}
              ViewParts={(e) => {
                ViewFunctions(e);
              }}
              dtpageindex={dtpageindex}
              MakeCreate={filterForWhite.white_collar ? true : false}
              //---Month based filter
              // MonthFilter={true}
              // yearAndMonth={yearAndMonth}
              /// for the month filter
//      Month_date_pick={true}
//                                     nostatusFilter={true}
//                                     value_of_monthDate={Datamonth}
// onChange_ofMonthDate={setdata}  

              handleChange={handleChange}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}

              Filter={true}
              Superviorsfilter={false}
              OldEmployeFilters={false}
              // nostatusFilter={true}
              ///----

              ///--- emoloyee role based filters -
              EmployeeRoleTrue={false}
              EmployeeRoleOption={EmpRoles}
              EMpROleSelected={EMpROleSelected}
              HandleEMprole={HandleEMprole}
              ///---kyc---
              KYC={true}
              KYCoptionsTable={KYCoptions}
              KycValue={KycValue}
              HandleKyc={HandleKyc}
                     searchVal={TablePositionPersist?.UDSUserDatas?.search == "" || TablePositionPersist?.UDSUserDatas?.search ==undefined? "":TablePositionPersist.UDSUserDatas.search}
              search_key={true}
              nostatusFilter={true}
            />
          </div>
        ) : null}
      </div>

      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletePopup}
          onSubmit={HandleSubmits}
          Content={"Do you want to delete the User"}
        />
      ) : null}

      {/* { UserCreate ?
       <UserCreateForm show={UserCreate}  setShow={setUserCreate} currentPage={currentPage} />
     :
     null
      
     } */}

      {EditId != undefined && currentPage != undefined && UserEditPopup ? (
        <UserCreateForm
          show={UserEditPopup}
          EditId={EditId}
          setShow={setUserEditPopup}
          currentPage={dtpageindex}
          white_collar={filterForWhite.white_collar}
          search={search}
          datafilter={data}
          role_filter={RoleID.roleid}
        />
      ) : null}


    </>
  );
};

export default UserDetails;
